import React from 'react';


const LegalPage = ({ content }) => {
    const [isDropDownOepn, setDropDown] = React.useState(false);
    return (
        <>
            <div className="single-pg" >
                <div className="container">
                    <div className="row-wrap mx-0">
                        <div className="col-12 content-box">
                            <div className="intro-box">
                                {
                                    content.title &&
                                    <h1 className="heading has-line left-line">{content.title.rendered}</h1>
                                }
                                {
                                    content.acf.intro_content && <div dangerouslySetInnerHTML={{ __html: content.acf.intro_content }}></div>
                                }

                            </div>
                            <div className="versionBox">
                                {
                                    content.acf.cta_download_pdf &&
                                    <div className="pdfDownload">
                                        <span className="text">{content.acf.blue_text}</span> <a href={content.acf.cta_download_pdf.url} className="viewPdf" target={content.acf.cta_download_pdf.target}>{content.acf.cta_download_pdf.title}</a>
                                    </div>
                                }
                                <hr />
                                {
                                    content.acf.previous_versions && !!content.acf.previous_versions.length &&
                                    <div className="dropbox">
                                        <div className={`dropHeading ${isDropDownOepn ? 'dropOpen' : ''}`} onClick={() => setDropDown(!isDropDownOepn)} ><span className="text"></span> {content.acf.previous_version_label}<span className="arrow"></span></div>
                                        <div className="dropContent">
                                            <ul>
                                                {
                                                    content.acf.previous_versions.map((obj, index) => {
                                                        return (
                                                            <li key={index}><span className="text">{obj.version_label}</span> <a href={obj.pdf_cta_link.url} className="viewPdf" target={obj.pdf_cta_link.target === "" ? "_self" : "_blank"} onClick={() => setDropDown(false)} rel="noreferrer">{obj.pdf_cta_link.title}</a></li>
                                                        )
                                                    })
                                                }

                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: content.content.rendered }}>

                            </div>
                            {/* <p>Why should I read this policy?</p>
                            <p>This Privacy Policy (‘policy’) describes how Demivolt, UAB (‘we’, ‘our’, ‘us’ or ‘Demivolt) collects, uses, and stores your personal data and what statutory rights do you have.</p>
                            <p>We protect your personal data under the EU General Data Protection Regulation (2016/679) (‘GDPR’) and other applicable laws.</p>
                            <p>We may amend this policy unilaterally from time to time. Any such amendments will be effective immediately upon publication, therefore please visit our website regularly for the latest version of this policy.</p>
                            <p>Who is responsible for protecting my information?</p>
                            <p>We are: Demivolt, UAB, a licensed electronic money institution (License No 77 issued on 26 November 2020). We provide payment services and we are supervised by the Bank of Lithuania.</p>
                            <p>Our company number is: 305562462</p>
                            <p>Our address is: Jogailos str. 4, LT-01116 Vilnius, the Republic of Lithuania</p>
                            <p>Our e-mail address: <a href="mailto:info@demivolt.com">info@demivolt.com</a></p>
                            <p>For your convenience below please find the Table of Contents of this Policy</p>
                            <br></br>
                            <ol>
                                <li>Why and how do you collect and use my data
                                    <ol>
                                        <li>To identify you</li>
                                        <li>To provide payment services to you or a company represented by you.</li>
                                        <li>To implement measures of anti-money laundering (AML) and counter terrorist financing (CTF)</li>
                                        <li>To ensure security of our website/internet bank/mobile application and continuously improve it</li>
                                        <li>To provide you with customer support</li>
                                        <li>To conduct marketing activities</li>
                                        <li>To manage our social media profiles</li>
                                        <li>To carry out the selection of potential employees</li>
                                        <li>To fulfill statutory accounting requirements</li>
                                        <li>To defend our rights and interests and fulfill other statutory requirements</li>
                                    </ol>
                                </li>
                                <li>Who do you share my data with </li>
                                <li>What statutory rights do I have regarding my data</li>
                                <li>Do you engage in automated individual decision-making, including profiling</li>
                                <li>How can I manage cookies</li>
                                <li>How can I contact your DPOs</li>
                            </ol>
                            <hr />
                            <p>In general, we collect and use your personal data for the purposes of provision of payment services. There are also other purposes related to the provision of payment services, internal administration, and legal processes for which we collect and process your personal data. You can find more detailed information on personal data categories, legal basis for the processing of personal data, personal data retention periods, etc. in the tables below: </p>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td width="103">
                                            <p><strong>When is this relevant for me?</strong></p>
                                        </td>
                                        <td width="180">
                                            <p><strong>What information do you collect about me?</strong></p>
                                        </td>
                                        <td width="122">
                                            <p><strong>What is your legal basis to collect my data?</strong></p>
                                        </td>
                                        <td width="96">
                                            <p><strong>Where do you collect the information from?</strong></p>
                                        </td>
                                        <td width="107">
                                            <p><strong>Am I obliged to provide this information? </strong></p>
                                        </td>
                                        <td width="100">
                                            <p><strong>How long do you store information about me?</strong></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" width="103">
                                            <p>When establishing a business relationship with us</p>
                                        </td>
                                        <td width="180">
                                            <p>Name and surname, ID number, personal code, sex, ID type, date of birth, ID issue/expiry date, nationality, country which issued ID, IP address, start and finish time of identification process, client ID, picture of document front side and back side, telephone number</p>
                                        </td>
                                        <td width="122">
                                            <p>Legal obligation</p>
                                            <p>(Art. 6 (1) (c) of GDPR)</p>
                                            <p>Art. 9 (1) (1) of the Law on the Prevention of Money Laundering and Terrorist Financing of the Republic of Lithuania (Law on AML)</p>
                                        </td>
                                        <td rowspan="2" width="96">
                                            <p>From yourself</p>
                                        </td>
                                        <td rowspan="2" width="107">
                                            <p>It is a statutory requirement and a requirement necessary to enter into a contract. If you or a company represented by you do not provide this information, we will not be able to provide our services</p>
                                        </td>
                                        <td rowspan="2" width="100">
                                            <p>For the duration of and 8 years after the termination of business relationship</p>
                                            <p>&nbsp;</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="180">
                                            <p>Biometrical data (facial image and short video)</p>
                                        </td>
                                        <td width="122">
                                            <p>Reasons of substantial public interest</p>
                                            <p>(Art. 9 (2) (g) of GDPR)</p>
                                            <p>Art. 11 (1) (4) (b) of the Law on AML</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <br></br>
                            <br></br>
                            <p><em>1.1. To identify you </em></p>
                            <p>When is this relevant for me?</p>
                            <p>What information do you collect about me?</p>
                            <p>What is your legal basis to collect my data?</p>
                            <p>Where do you collect the information from?</p>
                            <p>Am I obliged to provide this information?</p>
                            <p>How long do you store information about me?</p>
                            <p>When establishing a business relationship with us</p>
                            <p>Name and surname, ID number, personal code, sex, ID type, date of birth, ID issue/expiry date, nationality, country which issued ID, IP address, start and finish time of identification process, client ID, picture of document front side and back side, telephone number</p>
                            <p>Legal obligation</p>
                            <p>(Art. 6 (1) (c) of GDPR)</p>
                            <p>Art. 9 (1) (1) of the Law on the Prevention of Money Laundering and Terrorist Financing of the Republic of Lithuania (Law on AML)</p>
                            <p>From yourself</p>
                            <p>It is a statutory requirement and a requirement necessary to enter into a contra</p>
                            <br />
                            <br />
                            <p>Biometrical data (facial image and short video)</p>
                            <p>Reasons of substantial public interest</p>
                            <p>(Art. 9 (2) (g) of GDPR)</p>
                            <p>Art. 11 (1) (4) (b) of the Law on AML</p>
                            <br />
                            <br />
                            <p><em> 1.2. To provide payment services to you or a company represented by you </em></p>
                            <p>When is this relevant for me? </p>
                            <p>What information do you collect about me?</p>
                            <p>What is your legal basis to collect my data?</p>
                            <p>Where do you collect the information from?</p>
                            <p>Am I obliged to provide this information?</p>
                            <p>How long do you store information about me?</p>
                            <p>When you or the company represented by you access and use our systems (i.e., account in the systems, internet bank or mobile application) or use the payment services we offer to you, e.g., payment account services, electronic money issuance and redemption, payment initiation, account information, money transferring, or/and currency exchange services, acquiring, and other payment services that we are entitled to provide under our license.</p>
                            <br />
                            <br />
                            <p>Name and surname, e-mail address, telephone number, account number, number of payment account, amount of electronic money, payment denomination currency, applicable fee, payment order, receipt of a payment order, payment transaction, amount of payment transaction, commission fees and other payable fees, date and time of payment transaction, payee of payment transaction, payer of payment transaction, information about credit, account login credentials (PIN, password, one-time passwords), account creation date, other registration information, sort code and IBAN, and other unique identifiers of the payment accounts</p>
                            <br />
                            <br />
                            <p>Contract</p>
                            <p>(Art. 6 (1) (b) of GDPR)Legal obligation</p>
                            <p>(Art. 6 (1) (c) of GDPR)</p>
                            <p>Art. 15 (6), 62 (1) of the Law on Payments of the Republic of Lithuania</p>
                            <p>From yourself</p>
                            <p>It is a contractual and a statutory requirement. If you or the company represented by you do not provide this information, we will not be able to provide our services</p>
                            <p>For the duration of and 10 years after the termination of a contract</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LegalPage;